import { connect } from 'react-redux';

import { onSubmitChecklistItemAnswer } from '../../reducers/checklistItem.reducers';

import ChecklistItemGroup from './checklistItemGroup';

const mapStateToProps = (state) => ({
  checklistItems: state.checklistItemGroup.checklistItems,
  checklistRun: state.checklist.selectedChecklistRun,
  checklistItemAnswers: state.checklistItem.checklistItemAnswers,
});

const mapDispatchToProps = (dispatch) => ({
  saveChecklistItemAnswer: (checklistItemAnswer) => {
    dispatch(onSubmitChecklistItemAnswer(checklistItemAnswer));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistItemGroup);



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklistItemGroup.container.js